module.exports = __webpack_public_path__ + "img/student_code_bg.6c3f012.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/student_code_bg.png
// module id = DTx+
// module chunks = 1